import React, { useCallback, useState } from 'react';
import { useEffect } from 'react';
import PowerStripSocket from "../../../assets/img/dashboard/powerStripSocket";
import PowerStripUsb from "../../../assets/img/dashboard/powerStripUsb";

const PowerStripType = ({ selectedItem, handlePostData, action }) => {
    
    const [powerStrip, setPowerStrip] = useState(null);
    
    useEffect(() => {
        setPowerStrip(selectedItem.deviceState);
    }, [selectedItem.deviceState, selectedItem.deviceState.power1, selectedItem.deviceState.power2, selectedItem.deviceState.power3, selectedItem.deviceState.power4, selectedItem.deviceState.power5]);

	const handleIndividualPower = useCallback((key) => () => {
        handlePostData(key, !powerStrip[key]);
		action();
	}, [powerStrip, handlePostData, action]);

	const handleAllOnPower = useCallback(() => {
        handlePostData("power5", true);
		action();
	}, [handlePostData, action]);
    
    const handleAllOffPower = useCallback(() => {
        handlePostData("power5", false);
        action();
    }, [handlePostData, action]);
 
	return (
		<section className="device-setting-body">
            {powerStrip &&
                <div className="device-display powerstrip">
                    <div className="powerstrip-buttons">
                        <button onClick={handleIndividualPower('power1')} className={`${!powerStrip.power1 ? 'off' : ''}`}>
                            <small>소켓 1</small>
                            <PowerStripSocket />
                        </button>
                        <button onClick={handleIndividualPower('power2')} className={`${!powerStrip.power2 ? 'off' : ''}`}>
                            <small>소켓 2</small>
                            <PowerStripSocket />
                        </button>
                        <button onClick={handleIndividualPower('power3')} className={`${!powerStrip.power3 ? 'off' : ''}`}>
                            <small>소켓 3</small>
                            <PowerStripSocket />
                        </button>
                        <button onClick={handleIndividualPower('power4')} className={`${!powerStrip.power4 ? 'off' : ''}`}>
                            <small>USB</small>
                            <PowerStripUsb />
                        </button>
                    </div>
                </div>
            }
            
            <div className="device-control-wrap">
                <div className="device-control device-control-flex">
                    <button onClick={handleAllOnPower} className="powerstrip-button">
                        <span>모두 켜기</span>
                    </button>
                    <button onClick={handleAllOffPower} className="powerstrip-button">
                        <span>모두 끄기</span>
                    </button>
                
                </div>
            </div>
		</section>
	);
}

export default PowerStripType;